import { useEffect, useState } from 'react';

/**
 * useState that survives component unmount, backed by localStorage.
 *
 * Routes are lazy-mounted (see App.js), so navigating List → Calendar → List
 * unmounts the view and every plain useState filter snaps back to its default.
 * Same persistence approach as the workspace picker in lib/workspace.js.
 */
export default function usePersistedState(key, initial) {
  const [value, setValue] = useState(() => {
    try {
      const raw = localStorage.getItem(key);
      return raw === null ? initial : JSON.parse(raw);
    } catch {
      return initial;   // corrupt or unavailable storage: fall back, never throw
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch { /* private mode / quota — persistence is best-effort */ }
  }, [key, value]);

  return [value, setValue];
}
